import { render, staticRenderFns } from "./SectionWrapper.vue?vue&type=template&id=703542e1&"
import script from "./SectionWrapper.vue?vue&type=script&lang=js&"
export * from "./SectionWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports